/**
 * Conversation and Message related constants/enums
 */

export const CONVERSATION_TYPES = {
  LEAD: 'LEAD',
  CUSTOMER: 'CUSTOMER',
};

export const CONVERSATION_STATUS = {
  OPEN: 'OPEN',
  CLOSED: 'CLOSED',
  PAUSED: 'PAUSED',
};

export const MESSAGE_TYPES = {
  TEXT: 'TEXT',
  IMAGE: 'IMAGE',
  DOCUMENT: 'DOCUMENT',
  INTERACTIVE: 'INTERACTIVE',
  AUDIO: 'AUDIO',
  VIDEO: 'VIDEO',
  BUTTON: 'BUTTON',
};

export const MESSAGE_STATUS = {
  SENT: 'SENT',
  DELIVERED: 'DELIVERED',
  READ: 'READ',
  RECEIVED: 'RECEIVED',
};

export const MESSAGE_DIRECTION = {
  INBOUND: 'INBOUND',
  OUTBOUND: 'OUTBOUND',
};

export const AUTHOR_TYPES = {
  CUSTOMER: 'CUSTOMER',
  AGENT: 'AGENT',
};

export const CREATION_CHANNEL = {
  WHATSAPP: 'WHATSAPP',
  EMAIL: 'EMAIL',
  SMS: 'SMS',
};

export const INTERACTIVE_MESSAGE_TYPES = {
  BUTTON_REPLY: 'interactive_button_reply',
  LIST_REPLY: 'interactive_list_reply',
};

export const MEDIA_STATUS = {
  PENDING: 'PENDING',
  DELIVERED: 'DELIVERED',
  FAILED: 'FAILED',
};
